import { render, staticRenderFns } from "./PreformattedModal.vue?vue&type=template&id=3c7f3ad7&scoped=true&"
import script from "./PreformattedModal.vue?vue&type=script&lang=js&"
export * from "./PreformattedModal.vue?vue&type=script&lang=js&"
import style0 from "./PreformattedModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PreformattedModal.vue?vue&type=style&index=1&id=3c7f3ad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f3ad7",
  null
  
)

export default component.exports